// 配送日選択（/cart/shipping の .shipping_date_selection）の「指定なし」を「指定なし(最短)」にする。
// wuSiteResource2 の Shared/SiteCommon.ts の shippingDateSelectionReplace() の引き取り先（Issue #53）。
// autocomplete=off も旧実装どおり（ブラウザの戻るで前回の選択が復元されないように）。
// 同じ文言を二度置き換えても変わらないので、過渡期に旧実装と重なっても害はない。

export const SHIPPING_DATE_ANY = '指定なし'
export const SHIPPING_DATE_ANY_LABEL = '指定なし(最短)'

export function relabelShippingDate(select: HTMLSelectElement): number {
  select.setAttribute('autocomplete', 'off')
  let n = 0
  for (const opt of Array.from(select.options)) {
    if (opt.text === SHIPPING_DATE_ANY) {
      opt.text = SHIPPING_DATE_ANY_LABEL
      n++
    }
  }
  return n
}

export default function shippingDateLabel(): void {
  document.querySelectorAll<HTMLSelectElement>('.shipping_date_selection').forEach(relabelShippingDate)
}
